import { Component, OnDestroy, ElementRef, OnInit, ViewChild, OnChanges, SimpleChanges, ChangeDetectorRef, Injectable, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Location } from '@angular/common'
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { DailySales } from '../classes/reports';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

import { Message } from '../classes/message';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { GlobalsService } from '../services/globals.service';
import { PrintService } from '../services/print.service';
import { UsersService } from '../services/users.service';

import { DashboardService } from '../services/dashboard.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as Chartist from 'chartist';
import { Directive, HostListener, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';

import { Chart, registerables } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import autocolors from 'chartjs-plugin-autocolors';
import { OrdersService } from 'app/services/orders.service';
Chart.register(autocolors);


@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css'],
	animations: [
		trigger('flipState', [
			state('active', style({
				// transform: 'rotateY(179deg)',
				//safari does not like rotate Yputting the d
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			transition('active => inactive', animate('400ms ease-out')),
			transition('inactive => active', animate('400ms ease-in')),
			transition('inactive => orderlookup', animate('400ms ease-out')),
			transition('orderlookup => inactive', animate('400ms ease-in')),
		]),
		trigger('openClose', [
			state(':enter', style({ height: '*' })),
			state(':leave', style({ height: '0px' })),
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':enter, * => 0, * => -1', []),
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
					]),
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
					]),
				])
			]),
		]),
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0, overflow: 'hidden' })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class DashboardComponent implements OnInit {
	@ViewChild('monthView') monthViewRef: ElementRef;
	@ViewChild('print_table') printtable: ElementRef;
	@ViewChild('catChartRef') catChartRef!: ElementRef < HTMLCanvasElement > ;
	@ViewChild('customerTypeChartRef', { static: false }) customerTypeChartRef!: ElementRef < HTMLCanvasElement > ;
	customerTypeSales: any = [];
	catchart!: Chart;
	datepicked: any = false;
	public info = [];
	item: any = [];
	public ordersbyday: any = [];
	public max: any = [];
	public percentup: any = [];
	activeReport: any = 'Report 1';
	openorders: any = 'notready';
	needlocation: any = 'notready';
	negativestock: any = 'notready';
	newMessage: string;
	messageList: string[] = [];
	negativelink: any;
	needloclink: any;
	sender: any = [];
	flip = 'inactive';
	viewing: any = '';
	flip_text = '';
	color = 'blue'
	SENDER: any = [];
	messages = [];
	message: any = [];
	CHAT_ROOM = 'DashBoard';
	messageForm: any = [];
	carddate: any = [];
	posbyday: any = [];
	orderpweek: any = [];
	orderweek: any = [];
	config: any = false;
	popweek: any = [];
	poweek: any = [];
	popercentup: any = [];
	taxorders: any = [];
	thisoverlast: any = false;
	yearCount = 3;
	telegram_reports: string[] = ['Report 1', 'Report 2', 'Report 3', 'Report 4', 'Report 5'];
	datasource: any = false;

	linechart: any = false;
	customerTypeChart: any = false;
	public dataDailySalesChart: any = {
		labels: [],
		series: [],
	};

	catandlines: any = false;
	userData;
	hidedash: any = true;
	user: any;
	telegramAllowed = true;
	brandAllowed = true;
	category_table_data: any = [];
	line_table_data: any = [];
	openquotes: any = 'notready';
	isPosUser = false;
	categoryPie = true;
	linePie = true;
	customerTypePie: any = true;
	customerTypePieLoading: boolean;
	linePieLoading: boolean;
	categoryPieLoading: boolean;
	// quoteCount: any = false;
	days: any = 7;
	orderSubject: any = new BehaviorSubject < any > (null);
	orderWatcher$: any = this.orderSubject.asObservable();
	
	labelData:any = false;
	showLabelData:any = false;
	labelViewing: any = false;
	labelLoading: any = false;

	labeltype: any = false;
	prefix: any = false;

	// Component state

	constructor(private printService: PrintService, private router: Router, private sanitizer: DomSanitizer, public dashboardService: DashboardService, public formBuilder: UntypedFormBuilder, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private usersService: UsersService, private ordersService: OrdersService) {
		this.color = this.globalsService.getColor();
		this.userData = this.usersService.getLocalUser();

		// Initialize component

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			switch (this.config.env.package) {
			case 'tires':
				this.telegramAllowed = false;
				break;
			case 'beauty':


				if (this.userData.user.issalesman) {

					if (this.userData.user.group_level >= 3) {
						this.telegramAllowed = true;
						this.linePie = true;
						this.categoryPie = true;
						this.customerTypePie = true;
						this.brandAllowed = true;
					}

					if (this.userData.user.group_level < 3) {
						this.telegramAllowed = false;
						this.linePie = false;
						this.categoryPie = true;
						this.customerTypePie = false;
						this.customerTypePie = false;
						this.brandAllowed = false;
					}

				}
				this.usersService.isPosUser().subscribe((isPOS) => {
					if (isPOS) {
						this.isPosUser = true;
						this.telegramAllowed = false;
					}
				})
				break;
			}

			// Use async loading instead of blocking loadData()
			this.loadDataAsync();
		});
	}

	updateOrderSubject(newValue: any) {
		this.orderSubject.next(newValue);
	}

	ngOnInit() {
		this.globalSearchService.mesagesallowed.next(false);
		this.messageForm = this.formBuilder.group({
			message: '',
		});

		if (this.userData.user.issalesman && this.config.env.client == 'hairlines' && !this.isPosUser) {
			this.orderWatcher$.subscribe((orderCount) => {
				(orderCount && orderCount > 0) ? this.toggleFlip('Open Orders'): '';
			});
		}
	}

	viewHistory(month: any, year: any) {
		if (parseInt(month) < 10) {
			month = '0' + month;
		}

		const date = new Date(year + '-' + month + '-15')

		this.datepicked = date;

		this.modalService.open(this.monthViewRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {

		}, (reason) => {

		});

	}

	invoiceOrder(event: any) {
		this.router.navigate(['orders/invoice/' + event + '/dispatch']);
	}

	selectItemLookup(event: any) {

		if (this.isPosUser) {
			this.globalSearchService.setPreOrder(event);
			this.router.navigate(['./counter-pos/' + event.header.debtorno + '/' + event.header.branchcode]);
		} else {
			this.router.navigate(['./orders/entry/' + event.header.debtorno + '/' + event.header.branchcode]);
		}
	}

	getMonthYearQty(month: any, year: any) {

		const obj = year.qty.filter((monthyear: any) => {
			return monthyear.label == month;
		})[0];

		switch (obj.monthgrowth) {
		case -1:
			var color = '';
			break;
		default:
			var color = (obj.monthgrowth > 0) ? 'text-success' : 'text-danger'
			break;
		}

		switch (obj.monthpreviousgrowth) {
		case 0:
		case -1:
			var mcolor = '';
			break;
		default:
			var mcolor = (obj.monthpreviousgrowth > 0) ? 'text-success' : 'text-danger'
			break;
		}

		const returnValue = {
			percent_month: obj.monthpreviousgrowth,
			percent_month_color: mcolor,
			percent_month_icon: (obj.monthpreviousgrowth > 0) ? 'fa-long-arrow-up' : 'fa-long-arrow-down',
			percent: (obj.monthgrowth == -1) ? 0 : obj.monthgrowth,
			class: color,
			icon: (obj.monthgrowth > 0) ? 'fa-long-arrow-up' : 'fa-long-arrow-down',
		};

		return returnValue;
	}

	formatData(data: any[] = [], title: string, expanded = false): any {
		const _labels: string[] = [];
		const _series: number[] = [];
		const _colors: string[] = [];

		// Richer color palette (30+ unique colors)
		const colorPalette: string[] = [
			'#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f',
			'#edc949', '#af7aa1', '#ff9da7', '#9c755f', '#bab0ab',
			'#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
			'#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
			'#a05d56', '#6b486b', '#d0743c', '#ff8c00', '#98abc5',
			'#8a89a6', '#7b6888', '#6b486b', '#a05d56', '#d0743c'
		];

		if (!Array.isArray(data)) {data = [];}

		// Limit to top 10 by value unless expanded
		if (!expanded) {
			data = [...data]
				.sort((a, b) => (b.value ?? 0) - (a.value ?? 0))
				.slice(0, 10);
		}

		data.forEach((item, index) => {
			const label = item.label || '**UNKNOWN**';
			const value = this.config.env.package === 'tires' ? Number(item.qty || 0) : Number(item.value || 0);

			const color = colorPalette[index % colorPalette.length];

			_labels.push(label);
			_series.push(value);
			_colors.push(color);

			// Attach reference metadata for optional external legend use
			item.className = `bar-color-${index}`;
			item.color = color;
			item.displayValue = `$${value.toLocaleString()}`;
			item.tooltip = `${label}: $${value.toLocaleString()}`;
		});

		return {
			labels: _labels,
			datasets: [{
				fill: false,
				label: title,
				data: _series,
				backgroundColor: _colors,
				borderColor: _colors,
				borderWidth: 1,
				hoverOffset: 10,
			}]
		};
	}

	getCostTotalYear(year: any) {
		const value = year.cost.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.value);
			return accumulator + addon;
		}, 0);

		return value;
	}

	yearQtyGrowth(yearin: any) {

		// 		let value  = year.qty.reduce(function(accumulator: number, items: any) {
		// 			let addon = parseFloat(items.value);
		// 			return accumulator + addon;
		// 		}, 0);
		//
		// 		return value;
	}

	getSaleTotalYear(year: any) {
		let value = 0
		if (year) {
			value = year.sales.reduce(function(accumulator: number, items: any) {
				const addon = parseFloat(items.value);
				return accumulator + addon;
			}, 0);
		} else {
			value = 0
		}

		return value;
	}

	getQtyTotalYear(year: any) {
		const value = year.qty.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.value);
			return accumulator + addon;
		}, 0);

		return value;
	}

	quoteCount(e) {

	}

	subscritionsactive: any = [];
	overLastStatus: { loading: boolean;day: number;monthname: string;monthnum: number;fromyear: string;toyear: string;viewing: string;source: number;message: string;temp: { year: any;month: any; }; };
	lineover: any = false;
	categorySales: any = [];
	loadData() {

		this.ordersService.getOpenQuotes().subscribe(async (results: any) => {
			this.openquotes = results.length;
		});


		this.subscritionsactive.openorder = this.dashboardService.getOpenCOunt().subscribe(async (results: any) => {
			this.openorders = results.data;
			this.updateOrderSubject(results.data);
		});

		this.subscritionsactive.neg = this.dashboardService.getNegative().subscribe(async (results: any) => {
			this.negativestock = (results.data) ? results.data.length : 0;
		});

		this.subscritionsactive.needloc = this.dashboardService.getNeedLocation().subscribe(async (results: any) => {
			this.needlocation = results.data;
		});

		if (this.userData.user.issalesman) {
			const filters = { salesman: this.userData.user.salesman, yearCount: this.yearCount }
			this.subscritionsactive.thislast = this.dashboardService.getThisYearOverLastSalesman(filters).subscribe((results: any) => {
				this.thisoverlast = results;
			});
		} else {
			const filters = { yearCount: this.yearCount }
			this.subscritionsactive.thislast = this.dashboardService.getThisYearOverLast(filters).subscribe((results: any) => {
				this.thisoverlast = results;
			});
		}

		Chart.register(...registerables);
		Chart.register(ChartDataLabels);

		this.linePieLoading = true;
		this.categoryPieLoading = true;
		this.customerTypePieLoading = true
		this.subscritionsactive.catline = this.dashboardService.getCatAndLines().subscribe(async (results: any) => {
			this.catandlines = results;
			this.days = results.days;
			//double titles
			//const title = this.config.env.package == 'tires' ? 'Category Sales Last 7 Days' : 'Category Sales Last 7 Days';
			const title = '';

			this.categorySales = results.category_sales;
			if (this.catchart) {
				this.catchart.destroy();
			}
			if (this.categoryPie) {
				this.renderCategoryChart();
			}

			if (this.linechart) {
				this.linechart.destroy();
			}

			const linedata = this.formatData(results.line_sales, 'Product Line Sales', false);

			if(this.config.env.package === 'tires'){
				this.labeltype = 'Units';
				this.prefix = false;
			}else{
				this.labeltype = '$';
				this.prefix = true;
			}

			this.linechart = new Chart('plineChart', {
				type: 'bar',
				data: linedata,
				options: {
					indexAxis: 'y',
					responsive: true,
					maintainAspectRatio: false,
					plugins: {
						legend: { display: false },
						title: {
							display: false,
							text: 'Product Line Sales (Last 7 Days)',
							color: '#222',
							font: {
								size: 20,
								weight: 'bold',
								family: 'Segoe UI'
							},
							padding: { top: 10, bottom: 20 }
						},
						tooltip: {
							backgroundColor: '#333',
							titleColor: '#fff',
							bodyColor: '#eee',
							borderColor: '#999',
							borderWidth: 1,
							callbacks: {
								label: (context) => {
									if(this.prefix){
										return `${this.labeltype}${context.parsed.x.toLocaleString()}`;
									}else{
										return `${context.parsed.x.toLocaleString()} ${this.labeltype}`;
									}
								}
							}
						},
						datalabels: {
							color: '#000',
							anchor: (context) => {
								const value = Number(context.dataset.data[context.dataIndex]);
								const max = context.chart.scales.x.max || 1; // avoid division by 0
								const chartWidth = context.chart.chartArea.right - context.chart.chartArea.left;
								const pxValue = (value / max) * chartWidth;
								return pxValue > 80 ? 'center' : 'end';
							},
							align: (context) => {
								const value = Number(context.dataset.data[context.dataIndex]);
								const max = context.chart.scales.x.max || 1;
								const chartWidth = context.chart.chartArea.right - context.chart.chartArea.left;
								const pxValue = (value / max) * chartWidth;
								return pxValue > 80 ? 'center' : 'right';
							},
							formatter: (value) => {
								if(this.prefix){
									return `${this.labeltype}${value.toLocaleString()}`;
								}else{
									return `${value.toLocaleString()} ${this.labeltype}`;
								}
							},
							font: {
								size: 13,
								weight: 'bold'
							},
							clip: false
						}
					},
					scales: {
						x: {
							beginAtZero: true,
							ticks: {
								color: '#444',
								callback: (value) => {
									if(this.prefix){
										return `${this.labeltype}${value}`;
									}else{
										return `${value} ${this.labeltype}`;
									}
								}
							},
							grid: { color: '#eee' }
						},
						y: {
							ticks: {
								color: '#444',
								font: { size: 14 }
							},
							grid: { display: false }
						}
					},
					animation: {
						duration: 800,
						easing: 'easeOutQuart'
					}
				},
				plugins: [ChartDataLabels]
			});

			this.linePieLoading = false;

			if (this.customerTypeChart) {
				this.customerTypeChart.destroy();
			}


			if (this.customerTypePie && typeof this.customerTypePie.destroy === 'function') {
				this.customerTypePie.destroy();
			}

			this.customerTypeSales = results.customer_type_sales;

			this.renderCustomerTypeChart();

		});

		this.negativelink = this.config.apiServer.baseUrl + 'reports/report/html/?report=samples/221123110123.sql';
		this.needloclink = this.config.apiServer.baseUrl + 'reports/report/html/?report=samples/221122023111.sql';
		if (this.config.env.package === 'tires') {
			this.dashboardService.getReceievedTotalByDay().subscribe(async (results: DailySales) => {
				this.posbyday = results.data;
				this.poweek = results.week;
				this.popweek = results.pweek;
				this.popercentup = results.percentup;

				const labels = []
				const series = []
				this.posbyday.forEach((keys: any, vals: any) => {
					labels.push(keys.label)
					series.push(keys.count)
				});

				const datawebsiteViewsChart = {
					labels: labels,
					series: [
						series

					]
				};
				const optionswebsiteViewsChart = {
					lineSmooth: Chartist.Interpolation.cardinal({
						tension: 0
					}),
					axisX: {
						showGrid: false
					},
					//showArea: true,
					low: 0,
					high: results.max,
					chartPadding: { top: 0, right: 5, bottom: 0, left: 0 }
				};
				
				const websiteViewsChart = new Chartist.Line('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart);

				//start animation for the Emails Subscription Chart
				this.startAnimationForBarChart(websiteViewsChart);

			});
			this.dashboardService.getOrderCountByDay().subscribe(async (results: DailySales) => {

				this.ordersbyday = results.data;
				this.max = results.max;
				this.orderweek = results.week;
				this.orderpweek = results.pweek;

				this.percentup = results.percentup
				const dataDailySalesChart: any = {
					labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
					series: [
						[12, 17, 7, 17, 23, 18, 38]
					]
				};

				const labels = []
				const series = []
				this.ordersbyday.forEach((keys: any, vals: any) => {
					labels.push(keys.label)
					series.push(keys.count)
				});

				this.dataDailySalesChart.labels = labels;
				this.dataDailySalesChart.series = [series];

				const optionsDailySalesChart: any = {
					lineSmooth: Chartist.Interpolation.cardinal({
						tension: 0
					}),
					low: 0,
					high: this.max,
					chartPadding: { top: 0, right: 0, bottom: 0, left: 0 },
				}

				const dailySalesChart = new Chartist.Line('#dailySalesChart', this.dataDailySalesChart, optionsDailySalesChart);
				this.startAnimationForLineChart(dailySalesChart);

			});
		}
	}

	loadDataAsync() {
		// Load all data asynchronously without blocking UI
		this.loadAllData();
	}

	loadAllData() {
		// Load open orders
		this.dashboardService.getOpenCOunt().subscribe({
			next: (results: any) => {
				this.openorders = results.data;
				this.updateOrderSubject(results.data);
			},
			error: (error) => {
				console.error('Failed to load open orders:', error);
				this.openorders = 0; // Fallback value
			}
		});

		// Load quotes
		this.ordersService.getOpenQuotes().subscribe({
			next: (results: any) => {
				this.openquotes = results.length;
			},
			error: (error) => {
				console.error('Failed to load open quotes:', error);
				this.openquotes = 0;
			}
		});

		// Load negative inventory
		this.dashboardService.getNegative().subscribe({
			next: (results: any) => {
				this.negativestock = (results.data) ? results.data.length : 0;
			},
			error: (error) => {
				console.error('Failed to load negative inventory:', error);
				this.negativestock = 0;
			}
		});

		// Load need location data
		this.dashboardService.getNeedLocation().subscribe({
			next: (results: any) => {
				this.needlocation = results.data;
			},
			error: (error) => {
				console.error('Failed to load need location data:', error);
				this.needlocation = [];
			}
		});

		// Load year over year data
		if (this.userData.user.issalesman) {
			const filters = { salesman: this.userData.user.salesman, yearCount: this.yearCount }
			this.dashboardService.getThisYearOverLastSalesman(filters).subscribe({
				next: (results: any) => {
					this.thisoverlast = results;
				},
				error: (error) => {
					console.error('Failed to load year over year data:', error);
					this.thisoverlast = null;
				}
			});
		} else {
			const filters = { yearCount: this.yearCount }
			this.dashboardService.getThisYearOverLast(filters).subscribe({
				next: (results: any) => {
					this.thisoverlast = results;
				},
				error: (error) => {
					console.error('Failed to load year over year data:', error);
					this.thisoverlast = null;
				}
			});
		}

		// Load chart data in background
		this.loadChartData();
	}

	loadChartData() {
		// Initialize charts
		Chart.register(...registerables);
		Chart.register(ChartDataLabels);

		this.linePieLoading = true;
		this.categoryPieLoading = true;
		this.customerTypePieLoading = true;

		// Load category and line data
		this.dashboardService.getCatAndLines().subscribe({
			next: (results: any) => {
				this.catandlines = results;
				this.days = results.days;
				this.renderCategoryChart();
				this.renderCustomerTypeChart();
			},
			error: (error) => {
				console.error('Failed to load chart data:', error);
				this.linePieLoading = false;
				this.categoryPieLoading = false;
				this.customerTypePieLoading = false;
			}
		});

		// Load daily sales data
		this.dashboardService.getOrderCountByDay().subscribe({
			next: (results: any) => {
				this.ordersbyday = results.data;
				this.max = results.max;
				this.orderweek = results.week;
				this.orderpweek = results.pweek;
				this.percentup = results.percentup;
				
				// Update chart data
				const labels = [];
				const series = [];
				this.ordersbyday.forEach((keys: any, vals: any) => {
					labels.push(keys.label);
					series.push(keys.count);
				});
				
				this.dataDailySalesChart = {
					labels: labels,
					series: [series]
				};
			},
			error: (error) => {
				console.error('Failed to load daily sales data:', error);
			}
		});

		// Load POS data
		this.dashboardService.getReceievedTotalByDay().subscribe({
			next: (results: any) => {
				this.posbyday = results.data;
				this.poweek = results.week;
				this.popweek = results.pweek;
				this.popercentup = results.percentup;
			},
			error: (error) => {
				console.error('Failed to load POS data:', error);
			}
		});
	}




	startAnimationForPie(chart) {

		chart.on('draw', function(data) {

			if (data.type === 'slice') {
				// Get the total path length in order to use for dash array animation
				const pathLength = data.element._node.getTotalLength();

				// Set a dasharray that matches the path length as prerequisite to animate dashoffset
				data.element.attr({
					'stroke-dasharray': pathLength + 'px ' + pathLength + 'px'
				});

				// Create animation definition while also assigning an ID to the animation for later sync usage
				const animationDefinition = {
					'stroke-dashoffset': {
						id: 'anim' + data.index,
						dur: 5000,
						from: -pathLength + 'px',
						to: '0px',
						easing: Chartist.Svg.Easing.easeOutQuint,
						// We need to use `fill: 'freeze'` otherwise our animation will fall back to initial (not visible)
						fill: 'freeze',
						begin: 'anim' + (data.length - 1)
					}
				};

				// If this was not the first slice, we need to time the animation so that it uses the end sync event of the previous animation
				if (data.index !== 0) {
					animationDefinition['stroke-dashoffset'].begin = 'anim' + (data.index - 1) + '.end';
				}

				// We need to set an initial value before the animation starts as we are not in guided mode which would do that for us
				data.element.attr({
					'stroke-dashoffset': -pathLength + 'px'
				});

				// We can't use guided mode as the animations need to rely on setting begin manually
				// See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
				data.element.animate(animationDefinition, false);
			}
		});
		chart.on('created', function() {
			setTimeout(chart.update.bind(chart), 10000);
		});
	}

	startAnimationForLineChart(chart) {
		let seq: any, delays: any, durations: any;
		seq = 0;
		delays = 80;
		durations = 500;

		chart.on('draw', function(data) {
			if (data.type === 'line' || data.type === 'area') {
				data.element.animate({
					d: {
						begin: 600,
						dur: 700,
						from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
						to: data.path.clone().stringify(),
						easing: Chartist.Svg.Easing.easeOutQuint
					}
				});
			} else if (data.type === 'point') {
				seq++;
				data.element.animate({
					opacity: {
						begin: seq * delays,
						dur: durations,
						from: 0,
						to: 1,
						easing: 'ease'
					}
				});
			}
		});

		seq = 0;
	};

	startAnimationForBarChart(chart) {
		let seq2: any, delays2: any, durations2: any;

		seq2 = 0;
		delays2 = 80;
		durations2 = 500;
		chart.on('draw', function(data) {
			if (data.type === 'bar') {
				seq2++;
				data.element.animate({
					opacity: {
						begin: seq2 * delays2,
						dur: durations2,
						from: 0,
						to: 1,
						easing: 'ease'
					}
				});
			}
		});

		seq2 = 0;
	};

	randomString(length, chars) {
		let result = '';
		for (let i = length; i > 0; --i) { result += chars[Math.floor(Math.random() * chars.length)]; }
		return result;
	}

	toggleFlip(viewing: any) {
		this.viewing = viewing
		this.flip = (this.flip == 'active') ? 'inactive' : 'active';
	}

	toggleFlipTest(viewing: any) {
		switch(viewing?.comp) {
		case 'nopurch':
			this.viewing = viewing?.comp;
			break;
		case 'newcustomer':
			this.viewing = viewing?.comp;
			break;
		default: 
			this.viewing = viewing
			break;
		}

		return this.viewing;
	}

	nextChar(c) {
		return String.fromCharCode(c.charCodeAt(0) + 1);
	}

	getDataChartPoint(value: any, label: any, letter: any) {
		return {
			value: value,
			//name: label,
			className: 'ct-series-' + letter,
		}
	}

	ngOnDestroy() {

		if (this.subscritionsactive.openorder) {
			this.subscritionsactive.openorder.unsubscribe();
		}

		if (this.subscritionsactive.neg) {
			this.subscritionsactive.neg.unsubscribe();
		}

		if (this.subscritionsactive.thislast) {
			this.subscritionsactive.thislast.unsubscribe();
		}

		if (this.subscritionsactive.catline) {
			this.subscritionsactive.catline.unsubscribe();
		}

	}

	generateGradientColors(count: number) {
		const startColor = [255, 94, 98]; // Coral Red
		const endColor = [103, 58, 183]; // Deep Purple

		return Array.from({ length: count }, (_, i) => {
			const ratio = i / Math.max(count - 1, 1);
			const r = Math.round(startColor[0] + (endColor[0] - startColor[0]) * ratio);
			const g = Math.round(startColor[1] + (endColor[1] - startColor[1]) * ratio);
			const b = Math.round(startColor[2] + (endColor[2] - startColor[2]) * ratio);
			return `rgb(${r}, ${g}, ${b})`;
		});
	};

	renderCategoryChart() {
		if (this.catchart) {
			this.catchart.destroy(); // Prevent duplicate charts
		}
	
		const canvas = this.catChartRef?.nativeElement;
		const ctx = canvas.getContext('2d');
	
		if (!ctx) {
			console.error('Canvas context not found');
			return;
		}
	
		const gradient = this.generateGradientColors(this.categorySales.length);
	
		this.catchart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: this.categorySales.map(item => item.label),
				datasets: [{
					label: 'Total $',
					data: this.categorySales.map(item => item.value),
					backgroundColor: gradient,
					borderColor: gradient,
					borderWidth: 2,
					borderRadius: 8,
					hoverBackgroundColor: 'rgba(54, 162, 235, 1)',
					hoverBorderColor: 'rgba(75, 192, 192, 1)'
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				indexAxis: 'x', // vertical bars
				animation: {
					duration: 1500,
					easing: 'easeOutBounce'
				},
				scales: {
					x: {
						grid: { color: 'rgba(200, 200, 200, 0.3)' },
						title: {
							display: true,
							text: 'Product Category',
							color: '#333',
							font: { size: 14, weight: 'bold' }
						},
						ticks: {
							color: '#444',
							font: { size: 12 }
							// ✅ Removed incorrect $ formatting
						}
					},
					y: {
						beginAtZero: true,
						grid: { display: false },
						title: {
							display: true,
							text: 'Total $',
							color: '#333',
							font: { size: 14, weight: 'bold' }
						},
						ticks: {
							color: '#444',
							font: { size: 12 },
							callback: (value: number | string) => {
								const val = typeof value === 'string' ? parseFloat(value) : value;
								return `$${val.toLocaleString()}`;
							}
						}
					}
				},
				plugins: {
					legend: { display: false },
					title: {
						display: false,
						text: 'Total $ by Category',
						color: '#333',
						font: { size: 18, weight: 'bold' },
						padding: { top: 10, bottom: 20 }
					},
					tooltip: {
						backgroundColor: 'rgba(0, 0, 0, 0.8)',
						titleFont: { size: 16, weight: 'bold' },
						bodyFont: { size: 14 },
						borderColor: '#fff',
						borderWidth: 1,
						callbacks: {
							label: context => `$${context.parsed.y.toLocaleString()}`
						}
					},
					datalabels: {
						color: (ctx) => {
							const value = (ctx as any).raw;
							const yMax = ctx.chart.scales.y.max || 1;
							return value / yMax > 0.2 ? '#fff' : '#000';
						},
						align: (ctx) => {
							const value = (ctx as any).raw;
							const yMax = ctx.chart.scales.y.max || 1;
							return value / yMax > 0.2 ? 'center' : 'end';
						},
						anchor: 'end',
						formatter: (value: number) => `$${value.toLocaleString()}`,
						font: {
							size: 12,
							weight: 'bold'
						},
						clamp: true,
						clip: false,
						rotation: 0
					}
				}
			},
			plugins: [ChartDataLabels]
		});
	
		this.categoryPieLoading = false;
	}

	renderCustomerTypeChart() {
		if (this.customerTypeChart) {
			this.customerTypeChart.destroy(); // Prevent duplicate charts
		}

		const canvas = this.customerTypeChartRef?.nativeElement;
		if (!canvas) {
			console.error('Canvas element not found for customerTypeChart');
			return;
		}

		const ctx = canvas.getContext('2d');
		if (!ctx) {
			console.error('Canvas context not found');
			return;
		}

		this.customerTypeChart = new Chart(ctx, {
			type: 'bar', //  Horizontal bar chart
			data: this.getCustomerTypeChartData(),
			options: {
				indexAxis: 'y', //  Horizontal bar chart
				// responsive: true,
				// maintainAspectRatio: false,  //  Allows better scaling
				layout: {
					padding: { left: 10, right: 20, top: 10, bottom: 10 } //  Prevents label clipping
				},
				scales: {
					x: {
						beginAtZero: true,
						title: {
							display: true,
							text: 'Total Sales (Units)',
							color: '#333',
							font: {
								size: 14,
								weight: 'bold'
							}
						},
						ticks: {
							autoSkip: false, //  Prevents skipping of values
							maxRotation: 45, //  Rotates labels to 45 degrees
							minRotation: 45 //  Ensures labels always stay rotated
						},
						grid: {
							color: 'rgba(200, 200, 200, 0.3)' //  Clean grid lines
						}
					},
					y: {
						title: {
							display: true,
							text: 'Customer Type',
							color: '#333',
							font: {
								size: 14,
								weight: 'bold'
							}
						},
						ticks: {
							font: {
								size: 12, //  Adjust label size for better fit
								weight: 'bold'
							},
							padding: 5 //  Adds spacing between labels & bars
						},
						grid: {
							display: false //  Hide y-axis grid for cleaner look
						}
					}
				},
				plugins: {
					legend: {
						display: false //  Hide legend for cleaner look
					},
					title: {
						display: false,
						text: 'Customer Type Sales',
						font: {
							size: 16,
							weight: 'bold'
						},
						color: '#333'
					},
					tooltip: {
						callbacks: {
							label: (tooltipItem: any) => {
								const label = tooltipItem.label || '';
								const value = tooltipItem.raw || 0;
								return `${label}: ${value} units`;
							}
						}
					}
				}
			}
		});


	}

	/**  Function to structure chart data **/
	getCustomerTypeChartData() {
		const colors = [
			'#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'
		]; //  Custom color palette

		return {
			labels: this.customerTypeSales.map(item => item.label),
			datasets: [
				{
					label: 'Total Sales (Units)',
					data: this.customerTypeSales.map(item => item.qty), //  Using `qty`
					backgroundColor: this.customerTypeSales.map((_, i) => colors[i % colors.length]), //  Dynamic colors
					borderColor: this.customerTypeSales.map((_, i) => colors[i % colors.length]),
					borderWidth: 1,
					borderRadius: 8, //  Rounded edges
					hoverBackgroundColor: this.customerTypeSales.map((_, i) => this.adjustColorBrightness(colors[i % colors.length], 30)), //  Slightly brighter on hover
					hoverBorderColor: this.customerTypeSales.map((_, i) => this.adjustColorBrightness(colors[i % colors.length], -20)) //  Slightly darker border
				}]
		};
	}

	adjustColorBrightness(hex: string, percent: number): string {
		const num = parseInt(hex.replace('#', ''), 16);
		let r = (num >> 16) + percent;
		let g = ((num >> 8) & 0x00FF) + percent;
		let b = (num & 0x0000FF) + percent;

		r = Math.min(255, Math.max(0, r));
		g = Math.min(255, Math.max(0, g));
		b = Math.min(255, Math.max(0, b));

		return `rgb(${r}, ${g}, ${b})`;
	}


	getCatLabelData(label){
		this.labelViewing = label
		this.showLabelData = false;
		this.labelData = false;
		if(this.labelLoading){
			this.labelLoading = false;
		}

		this.labelLoading =  this.dashboardService.getNonStockData(label).subscribe((res: any) => {
			this.labelLoading = false;	
			let nonstock; 
			if(this.config.env.package == 'beauty'){
				nonstock = 'UNKOWN';
			}else{
				nonstock = this.config.features.nonstockitem;
			}

			if(res.success){
				let headers = ['Cust.', 'Orderno', 'SKU', 'Desc.', 'Date', 'By','Qty', 'Total' ]
				if(label === nonstock){
					if(this.config.env.package === 'tires'){
						headers =  ['Cust.','Orderno', 'Desc', 'Date.', 'By','Supplier', 'Partno', 'Designation','Qty', 'Total' ];
					}else{
						headers =  ['Cust.','Orderno', 'Desc', 'Date.', 'By','Supplier', 'Partno', 'Qty', 'Total' ];
					}
				}
				
				let html = '<table class="table table-striped w-100"><thead><tr>';
				headers.forEach((v) => { 
					if(['total','qty'].includes(v)){
						html += '<th class="text-right">' + v + '</th>' 
					}else{
						html += '<th class="text-left">' + v + '</th>' 
					}
				})	
				html += '</tr></thead><tbody>'
				res.data.forEach((row) => {
					const date = new Date(row['trandate']);
						
					html += '<tr><td class="text-left" (click)="navigateToCustomer(row["debtorno"])"><span class="link">' + row['debtorno']+ '.' + row['branchcode']  + '</span></td>'
					html += '<td class="text-left">' + row['orderno'] + '</td>'
						
					if(label !== nonstock){ html += '<td class="text-left">' + row['stockid']  + '</td>' }
						
					html += '<td class="text-left">' + (row['itemdesc'] ? row['itemdesc'] : '-') + '</td>'
					html += '<td class="text-left">' + `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}` + '</td>'
					html += '<td class="text-left">' + (row['enteredby'] ? row['enteredby'] : '-') + '</td>'
						
					if(label === nonstock){
						html += '<td class="text-left">' + row['supplierno'] + ' : ' + row['suppname'] + '</td>'
						html += '<td class="text-left">' + row['suppliers_partno'] + '</td>'
						if(this.config.env.package === 'tires'){
							html += '<td class="text-left">' + row['designation'] + '</td>'
						}
					}
						
					html += '<td class="text-right">' + row['qty'] + '</td>'
					html += '<td class="text-right">' + row['total'] + '</td></tr>'
				})
				html += '</tbody></table>';
				this.labelData = html; 
				this.showLabelData = true;
			}else{
				this.labelData = false;
				this.showLabelData = false;
			}
		});
		
	}

	navigateToCustomer(debtorno){
		if(debtorno){
			this.router.navigate(['./customers/view/' + debtorno]);
		}
	}



	exportXls(input = false) {
		const now = new Date();
		let element = this.printtable?.nativeElement.innerHTML ?? '';
		let filename = 'ThisLast '
		if(input){
			element = input['html'];
			filename = input['name'];
		}
		const encoded: string = this.globalSearchService.base64encode(element);
		const data = {
			content: encoded,
			filename: filename + (now.getMonth() + 1) + now.getDate() + now.getFullYear(),
			//title: `This/Last - Created @ ${now.toLocaleString()}`,
			//subtitle: ''
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	exportPdf(input = false) {
		const now = new Date();
		let element = this.printtable?.nativeElement.innerHTML ?? '';
		let filename = 'ThisLast '
		let title = 'This/Last';
		if(input){
			element = input['html'];
			filename = input['name'];
			title = filename;
		}
		const encoded: string = this.globalSearchService.base64encode(element);
		const data = {
			content: encoded,
			filename: filename + (now.getMonth() + 1) + now.getDate() + now.getFullYear(),
			title: `${title} - Created @ ${now.toLocaleString()}`,
			subtitle: '',
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

}